import * as React from 'react';

export function Gmail({ fill = '#000', width = 25, height = 25, className, id, onClick }: any) {
    return (
        <svg width="1.3vw" height="1.1vw" viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 0H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 14h-2V5.2L10 9 4 5.2V14H2V2h1.2L10 6.2 16.8 2H18v12z" fill="#FFF" fill-rule="nonzero" />
        </svg>
    );
}
